import { Box, IStackProps, VStack } from 'native-base';
import React, { ReactNode } from 'react';

import { IconComponent, IconProps } from 'app/hocs/withIconWrapper';

export type ReservationDetailProps = IStackProps & {
  children?: ReactNode;
  Icon: IconComponent;
  _icon?: IconProps;
};

export default function ReservationDetail({
  children,
  Icon,
  _icon,
  ...props
}: ReservationDetailProps) {
  return (
    <VStack alignItems="center" space="2" testID="ReservationDetail" {...props}>
      <Box>
        <Icon color="white" size={24} {..._icon} />
      </Box>
      <Box>{children}</Box>
    </VStack>
  );
}
